import { FormFieldTypes } from "../../data/formFieldType";

const ResetPasswordFormData = {
  name: "Reset Password Form",
  initialState: {
    newPassword: "",
    confirmNewPassword: "",
  },
  formFields: [
    {
      id: "newPassword",
      lable: "Enter New Password",
      Field_Name: "password",
      fieldType: FormFieldTypes.PASSWORD,
      dataField: "newPassword",
      fieldSetting: {
        placeholder: "Password",
      },
      validation: [{ type: "require" }, { type: "password" }],
      style: {
        containerCss: "col-md-12 mb-3",
      },
    },
    {
      id: "confirmNewPassword",
      lable: "Confirm New Password",
      Field_Name: "confirm password",
      fieldType: FormFieldTypes.PASSWORD,
      dataField: "confirmNewPassword",
      fieldSetting: {
        placeholder: "Confirm Password",
      },
      validation: [
        { type: "require" },
        { type: "compare", compareEle: "newPassword" },
      ],
      style: {
        containerCss: "col-md-12 mb-3",
      },
    },
  ],
};

export default ResetPasswordFormData;
